export default __webpack_public_path__ + "static/media/analytics.a8911e94.png";